type AsyncFunction<T> = () => Promise<T>;

export function createPendingPromiseManager() {
  const pendingPromises: Map<string, Promise<any>> = new Map();

  async function load<T>(key: string, asyncFunc: AsyncFunction<T>, forceReload = false): Promise<T> {
    if (pendingPromises.has(key) && !forceReload) {
      return pendingPromises.get(key) as Promise<T>;
    }

    const promise = asyncFunc().finally(() => {
      pendingPromises.delete(key);
    });

    pendingPromises.set(key, promise);
    return promise;
  }

  function isLoadingResource(key: string): boolean {
    return pendingPromises.has(key);
  }

  function reset() {
    pendingPromises.clear();
  }

  return {
    load,
    reset,
    isLoadingResource
  };
}
